






import Vue from "vue";
import ResetPassword from "@/components/templates/ResetPassword/index.vue";
import snackbar from "@/shared/snackbar";

export default Vue.extend({
  components: { ResetPassword },

  methods: {
    async resetPassword(loginForm: any) {
      try {
        this.$store.dispatch("app/startRequest");
        const result = await this.$store.dispatch("auth/resetPassword", loginForm.newPassword);
        this.$store.dispatch("app/endRequest");
        snackbar.success(this, { message: "パスワードを変更しました。" });
        this.$router.push("/dashboard");
      } catch (err) {
        this.$store.dispatch("app/endRequest");
        snackbar.error(this, { message: `パスワードの設定に失敗しました。: ${err}` });
      }
    },
  },
});
